import state from './home.state';
import mutations from './home.mutation';
import actions from './home.action';
import getters from './home.getter';
import { Module } from 'vuex';

export enum homeMutations {
    SET_LIST_ITEM = 'SET_LIST_ITEM',
    SET_COUNT_NFT = 'SET_COUNT_NFT',
    SET_EXPIRED_BUY_NFT = 'SET_EXPIRED_BUY_NFT',
    SET_LIST_MY_COLLECTION_NOT_MINT = 'SET_LIST_MY_COLLECTION_NOT_MINT',
    SET_LIST_MY_COLLECTION_MINTED = 'SET_LIST_MY_COLLECTION_MINTED',

    SET_LIST_MY_COLLECTION = 'SET_LIST_MY_COLLECTION',
    SET_SELECT_ITEM = 'SET_SELECT_ITEM',
    SET_TO_WALLET = 'SET_TO_WALLET',
    CHECKOUT = 'CHECKOUT',
    SET_LIST_TOKEN_SELL = 'SET_LIST_TOKEN_SELL'
}

export interface IItem {
    name?: string;
    amount?: string;
    price?: string;
    price_usdt?: string;
    image?: string;
    status?: string;
    status_name?: string;
    open_sell_at?: string;
}

export interface IHomeState {
    listItems: IItem[];
    listCollectionsNotMint: [];
    listCollectionsMinted: [];
    countNtf: number;
    listTokenSell: Array<any> | string;
    feeSell: number
    expiredTimeBuy: number;
    reCallApi?: boolean;
}

export const home: Module<IHomeState, any> = {
    namespaced: true,
    state,
    mutations,
    actions,
    getters,
};
